module.exports = __webpack_public_path__ + "static/david-lynch-f7fbcfe418d4028cb3ab2bf367a8f948.jpg";